module.exports = __webpack_public_path__ + "static/media/chest-silver-70x70-2x.c8960980.png";